/* eslint-disable @typescript-eslint/no-unused-vars */
import { InputGraphNode } from '../../graph/InputGraphNode';

export class SeriesTypeNode {
    protected getSeriesType(node: InputGraphNode): string {
        if (node.seriesType) {
            const name = node.seriesType.toString().toLowerCase();
            return name === 'average' ? 'avg' : name;
        }

        return 'close';
    }
}
